module.exports = __webpack_public_path__ + "img/hk-back.5244c27d.png";